import { call, put, takeLatest } from "redux-saga/effects";
import { actions } from "./slice";
import * as API from "../../../../services/apis";

export function* handleResetPassword({ payload }) {
  try {
    const res = yield call(API.resetPassword, payload);
    const { data } = res;
    yield put(actions.resetPasswordSuccess(data));
    payload.onSuccess();
  } catch (err) {
    if (err?.response?.status === 400) {
      yield put(
        actions.resetPasswordFailure({
          message: "The link used for reset of password is expired",
        })
      );
    } else yield put(actions.resetPasswordFailure(err?.response?.data));
  }
}

/**
 * Root saga manages watcher lifecycle
 */
export function* resetPasswordSaga() {
  yield takeLatest(actions.resetPassword.type, handleResetPassword);
}
